import "./RoundedStatusBadge.scss";

import type { ReactNode } from "react";
import React, { memo } from "react";

interface IRoundedStatusBadgeProps {
  variant?: string;
  children: ReactNode | ReactNode[];
}

const RoundedStatusBadge: React.FC<IRoundedStatusBadgeProps> = memo(
  ({ children, variant = "" }) => {
    return <div className={`rounded-status-badge ${variant}`}>{children}</div>;
  },
);

export { RoundedStatusBadge };
